import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    myList:[]
};
const mutations= {
    setMyList(state, data){
        state.myList = data;
    }
};


export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/myList.js